import React, { useState, useEffect } from "react"
import { graphql, useStaticQuery, Link, navigate } from "gatsby"

import { Typeahead, withAsync } from "react-bootstrap-typeahead"
import "react-bootstrap-typeahead/css/Typeahead.css"

import API from "../../../api"

import { getCookie, eraseCookie, checkIfValidJSON } from "../../../service/helper"

// images
import logo from "../../../../static/assets/images/icons/hinduja-logo-mahim.svg"
import mobContactGIF from "../../../../static/assets/images/mob-menu-download-app.gif"
// import emergencyNumber from '../../../../static/assets/images/icons/emergency-number.svg'
// import bookAppointmentSVG from "../../../../static/assets/images/icons/book_an_appointment.svg"

import CommonSpec from "../commonSpecs"
import PopularSearch from "../popularSearch"

const AsyncTypeahead = withAsync(Typeahead)

const Accessibility = React.lazy(() =>
  import("./accessibility")
)

const Header = () => {
  let [searchList, setSearchList] = useState([])
  let [loading, setLoading] = useState(false)
  let [showMenu, setShowMenu] = useState(false)
  let [searchPlaceHolder, setSearchPlaceholder] = useState("Search Name/Specialities/Health Condition")
  let [userInfo, setUserInfo] = useState(getCookie("user"))
  const isUserLoggedIn = getCookie("login_id")
  const typeAheadRef = React.createRef()
  const isSSR = typeof window === "undefined"
  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    if (userInfo && checkIfValidJSON(userInfo)) {
      setUserInfo(JSON.parse(userInfo))
    }
  }, [])
  const logout = () => {
    if (isUserLoggedIn) {
      eraseCookie("login_id")
      eraseCookie("user")
      eraseCookie("hh")
      navigate('/')
    }
  }
  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      executeSearch()
    }
  }

  const executeSearch = () => {
    let trimSearchValue = searchValue.trim()
    if(searchValue?.length > 0 && trimSearchValue?.length) {
      closeSearch()
      navigate(`/search?search=${trimSearchValue}`)
      setSearchValue('')
    } 
  }

  const onSearchTextChange = data => {
    setSearchValue(data)
    const text = data
    if (text) {
      search(text)
    } else if (text.trim() === "") {
      clearData()
    }
  }

  const search = searchText => {
    setLoading(true)
    const json = {
      type: "all",
      categoryType: 'all',
      keyword: searchText,
    }
    API.siteSearch(json)
      .then(response => {
        if (response && response.length > 0) {
          const arr = response.map((el, index) => {
            return {
              ...el,
              id: "id-" + index,
              uniqueId: el?.id
            }
          })
          setSearchList(arr)
        }
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        setSearchList([])
        setLoading(false)
      })
  }

  const onSearchTextSelect = data => {
    if (data && data.length > 0) {
      const obj = data[0]
      if(obj?.uniqueId) {
        postDataForPopularSearch(obj?.uniqueId)
      }
      if (obj.path) {
        navigate(obj.path)
      }
    }
  }

  const postDataForPopularSearch = (id) => {
    API.postPopularSearch(id)
    .then(res => {
      console.log(res)
    })
    .catch(err => {
      console.log(err)
    })
  }

  const clearData = () => { }

  const openSearch = (event) => {
    if (typeof window !== "undefined" && typeof window.openSearchMenu !== "undefined") {
      window.openSearchMenu(event)
    }
  }

  const closeSearch = () => {
    if (typeof window !== "undefined" && typeof window.closeSearchMenu !== "undefined") {
      window.closeSearchMenu()
      if(typeAheadRef?.current?.clear) typeAheadRef.current.clear()
    }
  }

  const renderUserIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14.344"
        height="17"
        viewBox="0 0 14.344 17"
      >
        <g
          id="Group_902"
          data-name="Group 902"
          transform="translate(-21 -16)"
        >
          <g
            id="Group_901"
            data-name="Group 901"
            transform="translate(21 16)"
          >
            <path
              id="Path_1866"
              data-name="Path 1866"
              d="M28.57,25.031a4.516,4.516,0,1,0-.8,0A7.272,7.272,0,0,0,21,32.469V33H35.344v-.531A7.272,7.272,0,0,0,28.57,25.031Zm-3.852-4.516a3.453,3.453,0,1,1,3.453,3.453A3.446,3.446,0,0,1,24.719,20.516Zm-2.63,11.422a6.088,6.088,0,0,1,12.166,0Z"
              transform="translate(-21 -16)"
              fill="#024594"
            />
          </g>
        </g>
      </svg>
    )
  }

  const userDropdown = () => {
    setShowMenu(!showMenu)
  }

  const data = useStaticQuery(graphql`
  query headerMenu {
    allMenuItems(
      filter: {
        menu_name: { eq: "header" }
        parent: { id: { eq: null } }
      }
    ) {
      edges {
        node {
          title
          description
          url
          children {
            ... on MenuItems {
              url
              title
              description
            }
          }
        }
      }
    }
    allEntitySubqueuePopularSearches {
      nodes {
        searches: relationships {
          items {
            name
            link: field_link {
              uri
            }
          }
        }
      }
    }
    allEntitySubqueueCommonSpecialities {
      nodes {
        specialities: relationships {
          items {
            name
            link: field_link {
              uri
            }
          }
        }
      }
    }
  }
`)
  let commonSpecs = data && data?.allEntitySubqueueCommonSpecialities?.nodes ? data?.allEntitySubqueueCommonSpecialities?.nodes[0]?.specialities?.items : []
  commonSpecs = commonSpecs.map(el => {
    return {
      link: el?.link
        ? {
          ...el.link,
          title: el.name || "",
        }
        : {},
    }
  })

  let populerSearches = data && data?.allEntitySubqueuePopularSearches?.nodes
      ? data?.allEntitySubqueuePopularSearches?.nodes[0]?.searches?.items
      : []

  populerSearches = populerSearches.map(el => {
    return {
      link: el?.link
        ? {
          ...el.link,
          title: el.name || "",
        }
        : {},
    }
  })

  return (
    <header className="sticky-header">
      <div className="top_bar">
        <div className="container">
          <nav
            className="navbar navbar-expand-lg navbar-light flex-wrap"
            aria-label="top navigation"
          >
            <div
              className="collapse navbar-collapse
          navbarSupportedContent"
            >
              <ul className="navbar-nav ml-auto topnav">
                <li>
                  {!isSSR && (
                    <React.Suspense fallback={<div />}>
                      <Accessibility />
                    </React.Suspense>
                  )}
                </li>
                <li>
                  <Link to="/book-an-appointment">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.181"
                      height="18.913"
                      viewBox="0 0 19.181 18.913"
                    >
                      <g
                        id="Book_Icon"
                        transform="translate(-67.5 -316.063)"
                      >
                        <g
                          id="Group_885"
                          data-name="Group 885"
                          transform="translate(68 316.563)"
                        >
                          <path
                            id="Path_1829"
                            data-name="Path 1829"
                            d="M74.158,333.076H68.586a.586.586,0,0,1-.586-.586v-12.9a.586.586,0,0,1,.586-.586H83.835a.586.586,0,0,1,.587.586v5.278"
                            transform="translate(-68 -318.389)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="square"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <line
                            id="Line_54"
                            data-name="Line 54"
                            y2="1"
                            transform="translate(2.181)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <line
                            id="Line_55"
                            data-name="Line 55"
                            y2="1"
                            transform="translate(5.181)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <line
                            id="Line_56"
                            data-name="Line 56"
                            y2="1"
                            transform="translate(8.181)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <line
                            id="Line_57"
                            data-name="Line 57"
                            y2="1"
                            transform="translate(11.181)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <line
                            id="Line_58"
                            data-name="Line 58"
                            y2="1"
                            transform="translate(14.181)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <line
                            id="Line_59"
                            data-name="Line 59"
                            x2="12"
                            transform="translate(2.181 4)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="square"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                        </g>
                        <path
                          id="Path_1830"
                          data-name="Path 1830"
                          d="M103.451,351.451v3.226h-3.226v-3.226H97v-3.226h3.226V345h3.226v3.226h3.226v3.226Z"
                          transform="translate(-20.496 -20.201)"
                          fill="none"
                          stroke="#024594"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1"
                        />
                      </g>
                    </svg>
                    Book An Appointment
                  </Link>
                </li>
                <li>
                  <Link to="/online-services">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                    >
                      <g
                        id="online_medical_consultation-diagnosis"
                        data-name="online medical consultation-diagnosis"
                        transform="translate(-406.5 -115.5)"
                      >
                        <g
                          id="_Grupo_"
                          data-name="&lt;Grupo&gt;"
                          transform="translate(407 120.645)"
                        >
                          <g id="Group_896" data-name="Group 896">
                            <path
                              id="Path_1845"
                              data-name="Path 1845"
                              d="M409,142.161v-8.419A1.742,1.742,0,0,1,410.742,132h2.323"
                              transform="translate(-408.419 -132)"
                              fill="none"
                              stroke="#024594"
                              strokeLinecap="square"
                              strokeLinejoin="round"
                              strokeWidth="1"
                            />
                            <path
                              id="Path_1846"
                              data-name="Path 1846"
                              d="M457.065,142.161v-8.419A1.742,1.742,0,0,0,455.323,132H453"
                              transform="translate(-439.645 -132)"
                              fill="none"
                              stroke="#024594"
                              strokeLinecap="square"
                              strokeLinejoin="round"
                              strokeWidth="1"
                            />
                            <path
                              id="Path_1847"
                              data-name="Path 1847"
                              d="M422.968,173.032H409.032A2.032,2.032,0,0,1,407,171h7.258v.581h3.484V171H425A2.032,2.032,0,0,1,422.968,173.032Z"
                              transform="translate(-407 -159.677)"
                              fill="none"
                              stroke="#024594"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1"
                            />
                          </g>
                        </g>
                        <g id="doctor" transform="translate(409.031 116)">
                          <path
                            id="Path_1848"
                            data-name="Path 1848"
                            d="M414,147.548v-2.221a2.9,2.9,0,0,1,1.667-2.628l3.267-1.538.29-1.161"
                            transform="translate(-413.997 -133.032)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <path
                            id="Path_1849"
                            data-name="Path 1849"
                            d="M449.226,147.548v-2.221a2.9,2.9,0,0,0-1.667-2.628l-3.267-1.538L444,140"
                            transform="translate(-435.289 -133.032)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <path
                            id="Path_1850"
                            data-name="Path 1850"
                            d="M431.558,123.246c1.573-.674,1.746-2.1,1.917-3.5a3.828,3.828,0,0,0-.244-2.26,2.81,2.81,0,0,0-1.615-1.3,3.7,3.7,0,0,0-2.347,0,2.81,2.81,0,0,0-1.615,1.3,3.825,3.825,0,0,0-.243,2.26c.171,1.4.344,2.821,1.917,3.5"
                            transform="translate(-423.474 -116)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <path
                            id="Path_1851"
                            data-name="Path 1851"
                            d="M431,144c0,1.452,2.032,2.9,2.032,2.9s2.032-1.452,2.032-2.9"
                            transform="translate(-426.064 -135.871)"
                            fill="none"
                            stroke="#024594"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <g
                            id="Group_897"
                            data-name="Group 897"
                            transform="translate(1.743 8.129)"
                          >
                            <path
                              id="Path_1852"
                              data-name="Path 1852"
                              d="M427.407,144a2.9,2.9,0,0,0-1.452,2.9"
                              transform="translate(-424.214 -144)"
                              fill="none"
                              stroke="#024594"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1"
                            />
                            <path
                              id="Path_1853"
                              data-name="Path 1853"
                              d="M445,144c1.452.29,1.452,2.9,1.452,2.9v1.161"
                              transform="translate(-437.742 -144)"
                              fill="none"
                              stroke="#024594"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1"
                            />
                            <path
                              id="Path_1854"
                              data-name="Path 1854"
                              d="M420.871,157.484H420v-1.161c0-1.277.784-2.323,1.742-2.323h0c.958,0,1.742,1.045,1.742,2.323v1.161h-.871"
                              transform="translate(-420 -151.097)"
                              fill="none"
                              stroke="#024594"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1"
                            />
                            <circle
                              id="Ellipse_14"
                              data-name="Ellipse 14"
                              cx="1"
                              cy="1"
                              r="1"
                              transform="translate(7.226 3.871)"
                              fill="none"
                              stroke="#024594"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                    Online Services
                  </Link>
                </li>
                {!isSSR && (
                    <React.Suspense fallback={<div />}>
                      <>
                      {!isUserLoggedIn  ? 
                        <li className="dropdown">
                          <Link to="/user/login">
                            {renderUserIcon()}
                            Login
                          </Link>
                        </li> 
                      : 
                        <li className={`dropdown ${showMenu === true ? 'show' : ''}`}>
                            <a href="javascript:void(0);" className="profile-link" onClick={userDropdown}>
                              {renderUserIcon()}{userInfo && userInfo?.user_name ? userInfo.user_name : "User"}
                            </a>
                            <div className={`dropdown-menu ${showMenu === true ? 'show' : ''}`}>
                              <Link className="dropdown-item" to="/user/dashboard">Dashboard</Link>
                              <Link className="dropdown-item" to="/user/my-account">My Profile</Link>
                              <a className="dropdown-item" onClick={logout} href="javascript:void(0)">Logout</a>
                            </div>
                        </li>
                      }
                      </>
                    </React.Suspense>
                )}
                <li className="dropdown locationSec">
                    <span>Select Hospital</span>
                    <div className="locationSecInner">
                      <a href="#" className="activeLocation" type="button" data-toggle="dropdown">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9.947" height="12.631" viewBox="0 0 9.947 12.631">
                          <g id="Group_3917" data-name="Group 3917" transform="translate(0 0)">
                            <path id="Path_5888" data-name="Path 5888" d="M20.541,18.308a2.432,2.432,0,1,0,2.433,2.431,2.431,2.431,0,0,0-2.433-2.431m0,4.073a1.642,1.642,0,1,1,1.642-1.642,1.642,1.642,0,0,1-1.642,1.642" transform="translate(-15.567 -15.738)" fill="#fff" fill-rule="evenodd"></path>
                            <path id="Path_5889" data-name="Path 5889" d="M8.537,1.471a5.053,5.053,0,0,0-7.127,0A4.806,4.806,0,0,0,0,4.984,5.79,5.79,0,0,0,1.386,8.573L4.671,12.49a.394.394,0,0,0,.556.049.277.277,0,0,0,.049-.049L8.56,8.573A5.788,5.788,0,0,0,9.945,4.984,4.8,4.8,0,0,0,8.537,1.471M7.956,8.065,4.974,11.623,1.991,8.065a4.4,4.4,0,0,1-.022-6.037,4.256,4.256,0,0,1,6.01,0,4.4,4.4,0,0,1-.022,6.037" transform="translate(0 -0.001)" fill="#fff" fill-rule="evenodd"></path>
                          </g>
                        </svg>
                        <span>Mahim</span>
                      </a>
                      <div className="dropdown-menu">
                        <a className="dropdown-item" href="https://khar.hindujahospital.com/" target="_blank">
                          <svg xmlns="http://www.w3.org/2000/svg" width="9.947" height="12.631" viewBox="0 0 9.947 12.631">
                            <g id="Group_3917" data-name="Group 3917" transform="translate(0 0)">
                              <path id="Path_5888" data-name="Path 5888" d="M20.541,18.308a2.432,2.432,0,1,0,2.433,2.431,2.431,2.431,0,0,0-2.433-2.431m0,4.073a1.642,1.642,0,1,1,1.642-1.642,1.642,1.642,0,0,1-1.642,1.642" transform="translate(-15.567 -15.738)" fill="#fff" fill-rule="evenodd"></path>
                              <path id="Path_5889" data-name="Path 5889" d="M8.537,1.471a5.053,5.053,0,0,0-7.127,0A4.806,4.806,0,0,0,0,4.984,5.79,5.79,0,0,0,1.386,8.573L4.671,12.49a.394.394,0,0,0,.556.049.277.277,0,0,0,.049-.049L8.56,8.573A5.788,5.788,0,0,0,9.945,4.984,4.8,4.8,0,0,0,8.537,1.471M7.956,8.065,4.974,11.623,1.991,8.065a4.4,4.4,0,0,1-.022-6.037,4.256,4.256,0,0,1,6.01,0,4.4,4.4,0,0,1-.022,6.037" transform="translate(0 -0.001)" fill="#fff" fill-rule="evenodd"></path>
                      </g>
                    </svg>
                        Khar</a>
                      </div>
                    </div>  
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
      <nav
        className="navbar navbar-expand-lg flex-wrap p-0"
        aria-label="main navigation"
      >
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img className="lazyload" src={logo} alt="P.D. Hinduja Hospital" width="274" height="31" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target=".navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <i></i>
              <i></i>
              <i></i>
            </span>
          </button>
          <div className="btn_search show_on_mobile">
            <button
              title="Search"
              type="button"
              aria-label="Search button"
              onClick={(event) => openSearch(event)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32.959"
                height="32.959"
                viewBox="0 0 32.959 32.959"
              >
                <g transform="translate(-1153.5 -138.5)">
                  <g
                    data-name="Icon feather-search"
                    transform="translate(1155 140)"
                  >
                    <path
                      data-name="Path 252"
                      d="M30.564,17.532A13.032,13.032,0,1,1,17.532,4.5,13.032,13.032,0,0,1,30.564,17.532Z"
                      transform="translate(-4.5 -4.5)"
                      fill="none"
                      stroke="#fff"
                      strokeLinejoin="round"
                      strokeWidth="3"
                    />
                    <path
                      data-name="Path 253"
                      d="M33.137,33.137l-8.162-8.162"
                      transform="translate(-2.739 -2.739)"
                      fill="none"
                      stroke="#fff"
                      strokeLinejoin="round"
                      strokeWidth="3"
                    />
                  </g>
                </g>
              </svg>
            </button>
          </div>
          <ul className="navbar-nav ml-auto contact_nav">
            <li className="nav-item callus-item">
              {/* <a className="nav-link" href="javascript:void(0)">
                <img
                  className="lazyload"
                  src={bookAppointmentSVG}
                  alt=""
                />
                Appointment No.
              </a> */}
              <ul className="call_links">
                {/* <li>
                  24/7 Board :<a href="tel:02224452222">022 24452222</a> /{" "}
                  <a href="tel:02224451515">022 24451515</a>
                </li> */}
                <li>
                  <span>Appointment No.</span>:{" "}
                  <a href="tel:02267668181"> 022 67668181</a> /{" "}
                  <a href="tel:02245108181">022 45108181</a>
                </li>
              </ul>
            </li>
            <li className="nav-item callus-item">
              {/* <a className="nav-link" href="javascript:void(0)">
                <img className="lazyload" src={emergencyNumber} alt="" />
                Emergency No.
              </a> */}
              <ul className="call_links">
                <li>
                  <span>Emergency No.</span>: <a href="tel:02224452575">022 24452575</a> /{" "}
                  <a href="tel:09820885000">09820885000</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="switchLocationMainWrap">
          <div className="switchLocationinnerSec">
            <p>Select Hospital</p>
            <ul>
              <li className="dropdown locationSec">
                <div className="locationSecInner">
                  <a href="#" className="activeLocation" type="button" data-toggle="dropdown">
                    <svg xmlns="http://www.w3.org/2000/svg" width="9.947" height="12.631" viewBox="0 0 9.947 12.631">
                      <g id="Group_3917" data-name="Group 3917" transform="translate(0 0)">
                        <path id="Path_5888" data-name="Path 5888" d="M20.541,18.308a2.432,2.432,0,1,0,2.433,2.431,2.431,2.431,0,0,0-2.433-2.431m0,4.073a1.642,1.642,0,1,1,1.642-1.642,1.642,1.642,0,0,1-1.642,1.642" transform="translate(-15.567 -15.738)" fill="#fff" fill-rule="evenodd"></path>
                        <path id="Path_5889" data-name="Path 5889" d="M8.537,1.471a5.053,5.053,0,0,0-7.127,0A4.806,4.806,0,0,0,0,4.984,5.79,5.79,0,0,0,1.386,8.573L4.671,12.49a.394.394,0,0,0,.556.049.277.277,0,0,0,.049-.049L8.56,8.573A5.788,5.788,0,0,0,9.945,4.984,4.8,4.8,0,0,0,8.537,1.471M7.956,8.065,4.974,11.623,1.991,8.065a4.4,4.4,0,0,1-.022-6.037,4.256,4.256,0,0,1,6.01,0,4.4,4.4,0,0,1-.022,6.037" transform="translate(0 -0.001)" fill="#fff" fill-rule="evenodd"></path>
                      </g>
                    </svg>
                    <span>Mahim</span>
                  </a>
                  <div className="dropdown-menu">
                    <a className="dropdown-item" href="https://khar.hindujahospital.com/" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" width="9.947" height="12.631" viewBox="0 0 9.947 12.631">
                        <g id="Group_3917" data-name="Group 3917" transform="translate(0 0)">
                          <path id="Path_5888" data-name="Path 5888" d="M20.541,18.308a2.432,2.432,0,1,0,2.433,2.431,2.431,2.431,0,0,0-2.433-2.431m0,4.073a1.642,1.642,0,1,1,1.642-1.642,1.642,1.642,0,0,1-1.642,1.642" transform="translate(-15.567 -15.738)" fill="#fff" fill-rule="evenodd"></path>
                          <path id="Path_5889" data-name="Path 5889" d="M8.537,1.471a5.053,5.053,0,0,0-7.127,0A4.806,4.806,0,0,0,0,4.984,5.79,5.79,0,0,0,1.386,8.573L4.671,12.49a.394.394,0,0,0,.556.049.277.277,0,0,0,.049-.049L8.56,8.573A5.788,5.788,0,0,0,9.945,4.984,4.8,4.8,0,0,0,8.537,1.471M7.956,8.065,4.974,11.623,1.991,8.065a4.4,4.4,0,0,1-.022-6.037,4.256,4.256,0,0,1,6.01,0,4.4,4.4,0,0,1-.022,6.037" transform="translate(0 -0.001)" fill="#fff" fill-rule="evenodd"></path>
                        </g>
                      </svg>
                    Khar</a>
                  </div>
                </div>  
              </li>
            </ul>  
            </div>
      </div>
        <div className="break"></div>
        <div
          className="collapse navbar-collapse
      navbarSupportedContent main-nav"
        >
          <div className="container">
            <ul className="navbar-nav">
              {data &&
                data.allMenuItems &&
                data.allMenuItems.edges &&
                data.allMenuItems.edges.map((el, index) => {
                  if (el.node && el.node.children && el.node.children.length > 0) {
                    return (
                      <li key={index} className={`nav-item ${el.node.children.length > 0 ? 'dropdown' : ''}`}>
                        {" "}
                        {/* active */}
                        <a
                          className={`nav-link ${el.node.children.length > 0 ? 'dropdown-toggle' : ''}`}
                          href="#"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {el.node && el.node.title
                            ? el.node.title
                            : "Menu Title"}
                          &nbsp;
                        </a>
                        {(el.node && el.node.children && el.node.children.length > 0) &&
                          <div className="dropdown-menu">
                            <div className="container">
                              <ul className="row">
                                {el.node.children.map((child, i) => {
                                  return (
                                    <li
                                      className="col-md-4 col-lg-3"
                                      key={index + "-" + i}
                                    >
                                      <Link
                                        to={child.url ? child.url : "#"}
                                        activeClassName="active"
                                      >
                                        {child.title
                                          ? child.title
                                          : "Submenu Title"}
                                      </Link>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          </div>
                        }
                      </li>
                    )
                  } else {
                    return (
                      <li key={index} className={`nav-item ${el.node.children.length > 0 ? 'dropdown' : ''}`}>
                        {" "}
                        {/* active */}
                        <Link
                          className={`nav-link ${el.node.children.length > 0 ? 'dropdown-toggle' : ''}`}
                          to={el.node.url ? el.node.url : "#"}
                          activeClassName="active"
                        >
                          {el.node && el.node.title
                            ? el.node.title
                            : "Menu Title"}
                          &nbsp;
                        </Link>
                      </li>
                    )
                  }
                })}
              <li className="nav-item show_on_mobile">
                <Link
                  className="nav-link"
                  to="/book-an-appointment"
                >
                  Book an Appointment
                </Link>
              </li>
              <li className="nav-item show_on_mobile">
                <Link
                  className="nav-link"
                  to="/online-services"
                >
                  Online Services
                </Link>
              </li>
              <li className="nav-item show_on_mobile">
                {!isSSR && (
                  <React.Suspense fallback={<div />}>
                    <Accessibility isMobile={true} />
                  </React.Suspense>
                )}
              </li>
              
              <li className="nav-item dropdown show_on_mobile p-0"
                style={{
                  paddingTop: !isUserLoggedIn ? "10px" : "0",
                  paddingBottom: !isUserLoggedIn ? "10px" : "0"
                }}
              >
                {
                  !isUserLoggedIn ?
                    <Link to="/user/login" className="nav-link">
                      {renderUserIcon()}
                      <span className="ml-2">Login</span>
                    </Link>
                    :
                    <>
                      <a
                        className="nav-link dropdown-toggle"
                        href="javascript:void(0)"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {renderUserIcon()}
                        <span className="ml-2">
                          {
                            userInfo && userInfo?.user_name ? userInfo.user_name : "User"
                          }
                        </span>
                      </a>
                      <div className="dropdown-menu">
                        <ul>
                          <li>
                            <Link to="/user/dashboard">Dashboard</Link>
                          </li>
                          <li>
                            <Link to="/user/my-account">My Profile</Link>
                          </li>
                          <li>
                            <a onClick={logout} href="javascript:void(0)">Logout</a>
                          </li>
                        </ul>
                      </div>
                    </>
                }
              </li>
            </ul>
            <div className="show_on_mobile social_links_contact">
               <div className="emergency_contact_mob">
                  <p>Appointment No.</p>
                  <p className="contact_no"><a href="tel:02267668181">022 67668181</a> / <a href="tel:02245108181">022 45108181</a></p>
               </div>
               <div className="emergency_contact_mob">
                  <p>Emergency Contact</p>
                  <p className="contact_no"><a href="tel:02224452575">022 2445 2575</a> / <a href="tel:919820885000">+91 98 2088 5000</a></p>
               </div>
               <div className="social_icons">
                  <ul className="list-unstyled follow_links">
                  <li>
                  <a
                    target="_blank"
                    href=" https://www.linkedin.com/company/hinduja-hospital/"
                    aria-label="LinkedIn"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16.924"
                      height="18.849"
                      viewBox="0 0 16.924 18.849"
                    >
                      <path
                        id="Icon_zocial-linkedin"
                        data-name="Icon zocial-linkedin"
                        d="M-.09,2.3A2.224,2.224,0,0,1,.482.727,1.931,1.931,0,0,1,1.968.108,1.875,1.875,0,0,1,3.422.717a2.339,2.339,0,0,1,.572,1.637,2.175,2.175,0,0,1-.555,1.523,1.936,1.936,0,0,1-1.5.628H1.919A1.848,1.848,0,0,1,.465,3.878,2.3,2.3,0,0,1-.09,2.3ZM.122,18.957V6.239H3.749V18.957H.122Zm5.636,0H9.385v-7.1a3.157,3.157,0,0,1,.131-1.028,2.774,2.774,0,0,1,.694-1.095,1.618,1.618,0,0,1,1.168-.447q1.83,0,1.83,2.875v6.8h3.627V11.665a6.818,6.818,0,0,0-1.144-4.274,3.718,3.718,0,0,0-6.306.657v.038H9.369l.016-.038V6.239H5.758q.033.609.033,3.789T5.758,18.957Z"
                        transform="translate(0.09 -0.108)"
                        fill="#024594"
                      />
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/user/HindujaHospitalMRC"
                    aria-label="Youtube"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25.408"
                      height="19.97"
                      viewBox="0 0 25.408 19.97"
                    >
                      <path
                        id="Icon_simple-youtube"
                        data-name="Icon simple-youtube"
                        d="M24.881,5.8A3.407,3.407,0,0,0,22.67,3.309c-1.98-.6-9.951-.6-9.951-.6s-7.95-.012-9.951.6A3.407,3.407,0,0,0,.557,5.8,41.727,41.727,0,0,0,0,12.709,41.726,41.726,0,0,0,.557,19.6a3.407,3.407,0,0,0,2.211,2.487c1.978.6,9.951.6,9.951.6s7.949,0,9.951-.6A3.407,3.407,0,0,0,24.881,19.6a41.735,41.735,0,0,0,.53-6.888,41.735,41.735,0,0,0-.53-6.914ZM10.175,16.986V8.419l6.634,4.29Z"
                        transform="translate(-0.004 -2.712)"
                        fill="#024594"
                      />
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    href="https://twitter.com/HospitalHinduja"
                    aria-label="Twitter"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25.408"
                      height="20.657"
                      viewBox="0 0 25.408 20.657"
                    >
                      <path
                        id="Icon_zocial-twitter"
                        data-name="Icon zocial-twitter"
                        d="M-2.369,18.143q.62.06,1.239.061a10.247,10.247,0,0,0,6.486-2.23,5.023,5.023,0,0,1-3.036-1.034A5.08,5.08,0,0,1,.482,12.358a4.912,4.912,0,0,0,.971.083,5.106,5.106,0,0,0,1.384-.186A5.026,5.026,0,0,1-.169,10.469,5.051,5.051,0,0,1-1.357,7.153V7.09a4.89,4.89,0,0,0,2.375.64,5.117,5.117,0,0,1-1.7-1.849,5.082,5.082,0,0,1-.63-2.488A5.063,5.063,0,0,1-.592.77,14.493,14.493,0,0,0,4.149,4.623a14.673,14.673,0,0,0,6,1.6A5.861,5.861,0,0,1,10,5.026a5.013,5.013,0,0,1,1.529-3.677,5.038,5.038,0,0,1,3.7-1.529,5.008,5.008,0,0,1,3.8,1.653A10.488,10.488,0,0,0,22.337.193a4.968,4.968,0,0,1-2.272,2.892,10.643,10.643,0,0,0,2.975-.826,10,10,0,0,1-2.583,2.706v.683a14.948,14.948,0,0,1-.609,4.183,14.884,14.884,0,0,1-1.859,4.008A15.959,15.959,0,0,1,15,17.235,13.231,13.231,0,0,1,10.841,19.6a15.212,15.212,0,0,1-5.216.877A14.635,14.635,0,0,1-2.369,18.143Z"
                        transform="translate(2.369 0.18)"
                        fill="#024594"
                      />
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/HindujaHospital"
                    aria-label="Facebook"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12.704"
                      height="23.613"
                      viewBox="0 0 12.704 23.613"
                    >
                      <path
                        id="Icon_zocial-facebook"
                        data-name="Icon zocial-facebook"
                        d="M6.629,12.68V8.171h3.637V5.9a5.934,5.934,0,0,1,1.593-4.18A5.068,5.068,0,0,1,15.72,0h3.613V4.51H15.72a.8.8,0,0,0-.637.39,1.582,1.582,0,0,0-.283.956V8.17h4.533V12.68H14.8V23.613H10.265V12.68Z"
                        transform="translate(-6.629)"
                        fill="#024594"
                      />
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/hindujahospital/"
                    aria-label="Instagram"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23.613"
                      height="23.613"
                      viewBox="0 0 23.613 23.613"
                    >
                      <path
                        id="Icon_zocial-instagram"
                        data-name="Icon zocial-instagram"
                        d="M2.118,23.6a2.807,2.807,0,0,1-1.292-.734,2.6,2.6,0,0,1-.715-1.232C.028,21.307.024,21,.024,11.885.019,1.647.005,2.21.273,1.633A2.754,2.754,0,0,1,1.615.3c.6-.263.014-.249,10.33-.235l9.5.009.3.1a2.8,2.8,0,0,1,1.772,1.772l.1.3.009,9.5c.014,10.556.037,9.767-.3,10.45a2.741,2.741,0,0,1-1.167,1.167c-.674.332.092.309-10.353.3C3.821,23.664,2.354,23.655,2.118,23.6Zm18.391-2.81c.378-.268.388-.3.4-2.053.014-1.712,0-1.8-.277-2.072-.254-.249-.374-.263-2.044-.258l-1.523,0-.208.111a1.134,1.134,0,0,0-.341.323l-.138.2,0,1.527c0,.835.014,1.6.037,1.684a.862.862,0,0,0,.471.581l.231.115,1.6-.014,1.6-.014Zm-7.76-4.48a4.579,4.579,0,0,0,3.534-3.553,5.636,5.636,0,0,0,.051-1.5,4.647,4.647,0,0,0-2.367-3.4,4.951,4.951,0,0,0-1.218-.452c-.088-.009-.272-.037-.411-.06A4.558,4.558,0,0,0,8.222,9.112a4.514,4.514,0,0,0,.088,5.606,4.6,4.6,0,0,0,3.045,1.656A4.815,4.815,0,0,0,12.749,16.31ZM4.716,13.315a7.322,7.322,0,0,1,.609-4.683,6.787,6.787,0,0,1,1.38-1.9,7.2,7.2,0,0,1,6.279-2.049,7.309,7.309,0,0,1,5.878,5.352,7.165,7.165,0,0,1,.189,2.584,5.08,5.08,0,0,1-.189,1c-.014.023-.009.042.014.046.175.018,1.97.014,2-.009s.037-2.062.032-5.149L20.9,3.382l-.138-.2a1.153,1.153,0,0,0-.346-.3L20.2,2.773l-8.425.014L3.359,2.8,3.17,2.92a1.214,1.214,0,0,0-.3.3L2.764,3.4l-.014,5.1c0,2.805,0,5.117.009,5.144a4.965,4.965,0,0,0,1.029.046H4.8Z"
                        transform="translate(-0.022 -0.058)"
                        fill="#024594"
                      />
                    </svg>
                  </a>
                </li>
                  </ul>
               </div>
            </div>
            <div className="btn_search show_on_desktop">
              <button
                title="Search"
                type="button"
                aria-label="Search button"
                onClick={(event) => openSearch(event)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32.959"
                  height="32.959"
                  viewBox="0 0 32.959 32.959"
                >
                  <g transform="translate(-1153.5 -138.5)">
                    <g
                      data-name="Icon feather-search"
                      transform="translate(1155 140)"
                    >
                      <path
                        data-name="Path 252"
                        d="M30.564,17.532A13.032,13.032,0,1,1,17.532,4.5,13.032,13.032,0,0,1,30.564,17.532Z"
                        transform="translate(-4.5 -4.5)"
                        fill="none"
                        stroke="#fff"
                        strokeLinejoin="round"
                        strokeWidth="3"
                      />
                      <path
                        data-name="Path 253"
                        d="M33.137,33.137l-8.162-8.162"
                        transform="translate(-2.739 -2.739)"
                        fill="none"
                        stroke="#fff"
                        strokeLinejoin="round"
                        strokeWidth="3"
                      />
                    </g>
                  </g>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>
      <div className="search_box">
        <div className="container">
          <div className="input-group">
            <label htmlFor="globalSiteSearch" className="d-none">
            </label>
            {/* <input 
              onKeyDown={onKeyDown} 
              placeholder="Search Name/Specialities/Health Condition" 
              type="text" 
              class="rbt-input-main form-control rbt-input" 
              value={searchValue}
              onChange={(e) => setSearchValue(e?.target?.value)}
            /> */}
             <AsyncTypeahead
              delay={800}
              placeholder={searchPlaceHolder}
              labelKey="title"
              onSearch={onSearchTextChange}
              onChange={onSearchTextSelect}
              isLoading={loading}
              options={searchList}
              id="globalSiteSearch"
              searchText="Searching..."
              useCache={false}
              onBlur={() => setSearchPlaceholder("Search Name/Specialities/Health Condition")}
              onFocus={() => setSearchPlaceholder("")}
              ref={typeAheadRef}
              filterBy={(option, props) => {
                return option.title
              }}
            /> 
            <div className="input-group-append">
              <button
              onClick={executeSearch}
                className="btn btn-search"
                type="button"
                aria-label="Search"
              >
                <i className="icon-search">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25.155"
                    height="27.155"
                    viewBox="0 0 25.155 27.155"
                  >
                    <g
                      id="Group_1271"
                      data-name="Group 1271"
                      transform="translate(1.25 1.25)"
                    >
                      <path
                        data-name="Path 252"
                        d="M24.239,14.369A9.869,9.869,0,1,1,14.369,4.5a9.869,9.869,0,0,1,9.869,9.869Z"
                        transform="translate(-4.5 -4.5)"
                        fill="none"
                        stroke="#024594"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                      />
                      <path
                        data-name="Path 253"
                        d="M31.156,31.156l-6.181-6.181"
                        transform="translate(-8.135 -6.135)"
                        fill="none"
                        stroke="#024594"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                      />
                    </g>
                  </svg>
                </i>
              </button>
            </div>
            <div className="input-group-append">
              <button
                className="btn btn-close"
                type="button"
                aria-label="close search"
                onClick={closeSearch}
              >
                <i className="icon-close">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27.028"
                    height="27.028"
                    viewBox="0 0 27.028 27.028"
                  >
                    <path
                      id="Path_17"
                      data-name="Path 17"
                      d="M0,0H35.224"
                      transform="translate(1.061 1.061) rotate(45)"
                      fill="none"
                      stroke="#024594"
                      strokeLinejoin="round"
                      strokeWidth="3"
                    />
                    <path
                      id="Path_2073"
                      data-name="Path 2073"
                      d="M0,0H35.224"
                      transform="translate(25.968 1.061) rotate(135)"
                      fill="none"
                      stroke="#024594"
                      strokeLinejoin="round"
                      strokeWidth="3"
                    />
                  </svg>
                </i>
              </button>
            </div>
          </div>
          <div className="search_listing searchWrap_section">
            <div className="row">
              <CommonSpec className="col-md-6"/>
              <PopularSearch className="col-md-6"/>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header